import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'soe',
    loadChildren: () =>
      import('./modules/soe/soe.module').then(m => m.SoeModule)
  },
  {
    path: 'tci',
    loadChildren: () =>
      import('./modules/tci/tci.module').then(m => m.TciModule)
  },
  {
    path: 'actas',
    loadChildren: () =>
      import('./modules/actas/actas.module').then(m => m.ActasModule)
  },
  { path: '', redirectTo: 'soe', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SistemaAidRoutingModule { }
